export enum CustomerChatMessageType {
  EVENT = 'EVENT',
  MESSAGE_WEB = 'MESSAGE_WEB',
  MESSAGE_SMS = 'MESSAGE_SMS',
  MESSAGE_WHATSAPP = 'MESSAGE_WHATSAPP',
  MESSAGE_EMAIL = 'MESSAGE_EMAIL',
}

export enum CustomerChatMessageEvent {
  //auto responder
  AUTO_RESPONDER_NOT_AVAILABLE = 'AUTO_RESPONDER_NOT_AVAILABLE',
  //thread
  THREAD_CLOSED = 'THREAD_CLOSED',
  THREAD_REOPENED = 'THREAD_REOPENED',
  //bookings
  BOOKING_REFUNDED = 'BOOKING_REFUNDED',
  //reservations
  RESERVATION_REQUEST_CREATED = 'RESERVATION_REQUEST_CREATED',
  RESERVATION_CREATED = 'RESERVATION_CREATED',
  RESERVATION_CANCELLED = 'RESERVATION_CANCELLED',
  //guestlist
  GUEST_LIST_REQUEST_CREATED = 'GUEST_LIST_REQUEST_CREATED',
  GUEST_LIST_CREATED = 'GUEST_LIST_CREATED',
  GUEST_LIST_CANCELLED = 'GUEST_LIST_CANCELLED',
  //tickets
  TICKET_CREATED = 'TICKET_CREATED',
  TICKET_CANCELLED = 'TICKET_CANCELLED',
  //orders
  ORDER_CREATED = 'ORDER_CREATED',
}

export enum CustomerChatMessageState {
  SENT = 'SENT',
  RECEIVED = 'RECEIVED',
  READ = 'READ',
  DELIVERED = 'DELIVERED',
  FAILED = 'FAILED',
}

export enum CustomerChatMessageDirection {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
}

export enum CustomerChatMessageVisibility {
  PUBLIC = 'PUBLIC',
  PRIVATE = 'PRIVATE',
}

export enum CustomerChatMessageEventBusEvent {
  CREATED = 'CUSTOMER_CHAT_MESSAGE_CREATED',
}
